import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from 'src/app/core/base/base.service';
import { Observable } from 'rxjs';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';
import { ClientNumberModel } from '../../../../core/models/client-number-model';

@Injectable({
  providedIn: 'root',
})
export class SupplierClientNumberService extends BaseService<ClientNumberModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'supplier', authService);
  }

  downloadExcelTemplate(): Observable<ObjectApiInterface<any>> {
    return this.http.get<ObjectApiInterface<any>>(`${this.baseUrlApi}/download-excel-template-client-numbers`);
  }

  importClientNumbers(supplierId: string, payload: any): Observable<ObjectApiInterface<any>> {
    return this.http.post<ObjectApiInterface<any>>(
      `${this.baseUrlApi}/import-client-numbers/${supplierId}`,
      payload,
    );
  }
}
